import { render } from "./MarkedText.vue?vue&type=template&id=efdd8d0e&scoped=true"
import script from "./MarkedText.vue?vue&type=script&lang=js"
export * from "./MarkedText.vue?vue&type=script&lang=js"

import "./MarkedText.vue?vue&type=style&index=0&id=efdd8d0e&scoped=true&lang=css"

import exportComponent from "/home/www/.jenkins/workspace/131-front-vue-8081/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efdd8d0e"]])

export default __exports__